import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import About from './About';
import Work from './Work';
import Contact from './Contact';
import Blobs from '../components/Blobs';
import Footer from '../components/Footer';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <>
      <Hero />
      <About />
      <Work />
      <Contact />
      <Blobs />
      <div style={{ marginLeft: '24px' }}><Footer /></div>
    </>
  );
}


